import Vue from 'vue'
import { API_ROOT, STRIPE_PUBLISHABLE_KEY } from '../../config'
import { addToastMessage } from '../utils/toastErrorHandling'

const defaultPageSize = 25

export const getAllUsers = async (page, pageSize = defaultPageSize) => {
  try {
    return await Vue.axios.get(API_ROOT + '/users', { params: { page, pageSize } })
  } catch (err) {
    return addToastMessage(err)
  }
}

export const myUsers = async (page, pageSize = defaultPageSize) => {
  try {
    return await Vue.axios.get(API_ROOT + '/myusers', { params: { page, pageSize } })
  } catch (err) {
    return addToastMessage(err)
  }
}

export const getAllNutritionsists = async (page, pageSize = defaultPageSize) => {
  try {
    return await Vue.axios.get(API_ROOT + '/nutritionists', { params: { page, pageSize } })
  } catch (err) {
    return addToastMessage(err)
  }
}

export const getAllClients = async (id, page, pageSize = defaultPageSize) => {
  try {
    return await Vue.axios.get(API_ROOT + '/myclients/' + id, { params: { page, pageSize } })
  } catch (err) {
    return addToastMessage(err)
  }
}

export const signUpUser = async (data) => {
  try {
    return await Vue.axios.post(API_ROOT + '/portal/signup', data)
  } catch (err) {
    return addToastMessage(err)
  }
}

export const updatePortalUser = async (form, id) => {
  try {
    return await Vue.axios.put(API_ROOT + '/portal/users/' + id, form)
  } catch (err) {
    return addToastMessage(err)
  }
}

export const createClient = async (data) => {
  try {
    return await Vue.axios.post(API_ROOT + '/client/signup', data)
  } catch (err) {
    return addToastMessage(err)
  }
}

export const updateClient = async (id, data) => {
  try {
    return await Vue.axios.put(API_ROOT + '/client/signup/' + id, data)
  } catch (err) {
    return addToastMessage(err)
  }
}

export const putUserParents = async (id, data) => {
  try {
    return await Vue.axios.put(API_ROOT + '/client/parents/' + id, data)
  } catch (err) {
    return addToastMessage(err)
  }
}

export const postParseCSV = async (data) => {
  try {
    return await Vue.axios.post(API_ROOT + '/bulk/parse/', data)
  } catch (err) {
    return addToastMessage(err)
  }
}

export const postAssignClient = async (data) => {
  try {
    return await Vue.axios.post(API_ROOT + '/myclients', data)
  } catch (err) {
    return addToastMessage(err)
  }
}

export const postCreateGroup = async (data) => {
  try {
    return await Vue.axios.post(API_ROOT + '/groups', data)
  } catch (err) {
    return addToastMessage(err)
  }
}

export const fetchGroups = async (id, page, pageSize = defaultPageSize) => {
  try {
    return await Vue.axios.get(API_ROOT + '/groups/' + id, { params: { page, pageSize } })
  } catch (err) {
    return addToastMessage(err)
  }
}

export const postUpdateGroup = async (id, data) => {
  try {
    return await Vue.axios.put(API_ROOT + '/groups/' + id, data)
  } catch (err) {
    return addToastMessage(err)
  }
}

export const sendDeleteGroup = async (id) => {
  try {
    return await Vue.axios.delete(API_ROOT + '/groups/' + id)
  } catch (err) {
    return addToastMessage(err)
  }
}

export const fetchFileData = async (page, pageSize = 10000) => {
  try {
    return await Vue.axios.get(API_ROOT + '/files', { params: { page, pageSize } })
  } catch (err) {
    return addToastMessage(err)
  }
}

export const postCreateFile = async (data) => {
  try {
    return await Vue.axios.post(API_ROOT + '/files', data)
  } catch (err) {
    return addToastMessage(err)
  }
}

export const postUpdateFile = async (id, data) => {
  try {
    return await Vue.axios.put(API_ROOT + '/files/' + id, data)
  } catch (err) {
    return addToastMessage(err)
  }
}

export const sendDeleteFile = async (id, data) => {
  try {
    return await Vue.axios.delete(API_ROOT + '/files/' + id)
  } catch (err) {
    return addToastMessage(err)
  }
}

export const blanksurvey = async (data) => {
  try {
    return await Vue.axios.get(API_ROOT + '/surveys')
  } catch (err) {
    return addToastMessage(err)
  }
}

export const mynutritiondata = async (data) => {
  try {
    return await Vue.axios.get(API_ROOT + '/mysurveys')
  } catch (err) {
    return addToastMessage(err)
  }
}

export const submitstep = async (data, surveyId) => {
  try {
    return await Vue.axios.put(API_ROOT + '/mysurveys/' + surveyId, data)
  } catch (err) {
    return addToastMessage(err)
  }
}

export const postBiometrics = async (data) => {
  try {
    return await Vue.axios.post(API_ROOT + '/mybiometrics/', data)
  } catch (err) {
    return addToastMessage(err)
  }
}

export const putBiometrics = async (data, biometricsId) => {
  try {
    return await Vue.axios.put(API_ROOT + '/mybiometrics/' + biometricsId, data)
  } catch (err) {
    return addToastMessage(err)
  }
}

export const login = async (creds) => {
  let data = creds
  data.grant_type = 'password'
  data.client_id = '0'
  try {
    const response = await Vue.axios.post(API_ROOT + '/auth/token', data)
    return await refreshToken(response.data)
  } catch (error) {
    console.log(error)
    return addToastMessage(error)
  }
}

export const refreshToken = async (token) => {
  let data = {
    grant_type: 'refresh_token',
    refresh_token: token.refresh_token,
    client_id: '0'
  }
  try {
    const response = await Vue.axios.post(API_ROOT + '/auth/token', data)
    return response.data
  } catch (error) {
    console.log(error)
    throw error
  }
}

export const forgotPassword = async (data) => {
  try {
    return await Vue.axios.post(API_ROOT + '/auth/reset/request', data)
  } catch (error) {
    console.log(error)
    return error
  }
}

export const resetPassword = async (data) => {
  try {
    const response = await Vue.axios.post(API_ROOT + '/auth/reset', data)
    return await login({ username: response.data.email, password: data.password })
  } catch (error) {
    console.log(error)
    throw error
  }
}

export const signup = async (data) => {
  try {
    return await Vue.axios.post(API_ROOT + '/signup', data)
  } catch (err) {
    throw err
  }
}

export const verifyUser = async (data) => {
  try {
    // login straight away
    const response = await Vue.axios.post(API_ROOT + '/auth/verify', data)
    return await login({ username: response.data.email, password: data.password })
  } catch (err) {
    throw err
  }
}

export const activities = async (data) => {
  try {
    return await Vue.axios.get(API_ROOT + '/activities')
  } catch (err) {
    throw err
  }
}

export const resendcode = async (data) => {
  try {
    return await Vue.axios.post(API_ROOT + '/auth/resendcode', data)
  } catch (err) {
    throw err
  }
}

export const fetchMessages = async () => {
  try {
    return await Vue.axios.get(API_ROOT + '/mymessages', { params: { pageSize: 10000 } })
  } catch (err) {
    throw err
  }
}

export const fetchMessageThread = async (messageId, skip) => {
  try {
    let params = { messageId: messageId, pageSize: 25, skip: skip }
    return await Vue.axios.get(API_ROOT + '/messagethread', { params: params })
  } catch (err) {
    throw err
  }
}

export const fetchMessageThreadCount = async (messageId) => {
  try {
    return await Vue.axios.get(`${API_ROOT}/messagecount/${messageId}`)
  } catch (err) {
    throw err
  }
}

export const fetchParticipantInfo = async (participant) => {
  try {
    return await Vue.axios.get(`${API_ROOT}/participantinfo/${participant._id}`)
  } catch (err) {
    throw err
  }
}
export const sendMessage = async (data) => {
  try {
    return await Vue.$socketApi.sendMessage('nutricom.MessagingParticipant::messageSend', data)
  } catch (err) {
    throw err
  }
}

export const checkConnection = (data) => {
  try {
    Vue.$socketApi.checkConnection(data)
  } catch (err) {
    throw err
  }
}

export const updatemessage = async (data) => {
  try {
    return await Vue.axios.put(API_ROOT + '/markmessage/' + data._id, data)
  } catch (err) {
    throw err
  }
}

export const readMessage = (data) => {
  return Vue.$socketApi.sendMessage('nutricom.MessagingParticipant::messageRead', data)
}

export const fetchParticipantConsent = async (messageThreadId) => {
  try {
    return await Vue.axios.get(`${API_ROOT}/participantconsent/${messageThreadId}`)
  } catch (err) {
    throw err
  }
}

export const updatemyconsents = async (data) => {
  try {
    return await Vue.axios.post(API_ROOT + '/myconsents/', data)
  } catch (err) {
    throw err
  }
}

export const myinfo = async () => {
  try {
    return await Vue.axios.get(API_ROOT + '/me')
  } catch (err) {
    throw err
  }
}

export const userinfo = async (userId) => {
  try {
    return await Vue.axios.get(API_ROOT + '/tenant/57daf8c5239b461902e23374/admin/users/' + userId)
  } catch (err) {
    throw err
  }
}

export const updateprofile = async (data, userId) => {
  try {
    return await Vue.axios.put(API_ROOT + '/myaccount/' + userId, data)
  } catch (err) {
    throw err
  }
}

export const unsubscribe = async (userId) => {
  try {
    return await Vue.axios.put(API_ROOT + '/unsubscribe/' + userId)
  } catch (err) {
    throw err
  }
}

export const requestConsent = async (userId) => {
  try {
    return await Vue.axios.put(API_ROOT + '/requestconsent/' + userId)
  } catch (err) {
    throw err
  }
}

export const clientInfo = async (userId) => {
  try {
    return await Vue.axios.get(API_ROOT + '/me/' + userId)
  } catch (err) {
    throw err
  }
}

export const fetchStripePublishableKey = async () => {
  return STRIPE_PUBLISHABLE_KEY
}

export const fetchProducts = async () => {
  try {
    return await Vue.axios.get(`${API_ROOT}/products`, { params: { pageSize: 10000 } })
  } catch (err) {
    throw err
  }
}

export const fetchPlans = async product => {
  let params = { product: product, pageSize: 10000 }
  try {
    return await Vue.axios.get(`${API_ROOT}/plans`, { params: params })
  } catch (err) {
    throw err
  }
}

export const fetchMySubscriptions = async () => {
  try {
    return await Vue.axios.get(`${API_ROOT}/mysubscriptions`)
  } catch (err) {
    throw err
  }
}

export const fetchActiveSubscriptions = async () => {
  try {
    return await Vue.axios.get(`${API_ROOT}/activesubscriptions`)
  } catch (err) {
    throw err
  }
}

export const fetchActiveUserSubscriptions = async data => {
  try {
    return await Vue.axios.get(`${API_ROOT}/activesubscriptions/` + data)
  } catch (err) {
    throw err
  }
}

export const postNewSubscription = async data => {
  try {
    return await Vue.axios.post(`${API_ROOT}/mysubscriptions`, { params: data })
  } catch (err) {
    throw err
  }
}

export const postNewClientSubscription = async data => {
  try {
    return await Vue.axios.post(`${API_ROOT}/client/subscriptions`, data)
  } catch (err) {
    throw err
  }
}

export const changeSubscription = async (id, data) => {
  try {
    return await Vue.axios.put(`${API_ROOT}/mysubscriptions/${id}`, data)
  } catch (err) {
    throw err
  }
}

export const deleteSubscription = async id => {
  try {
    return await Vue.axios.delete(`${API_ROOT}/mysubscriptions/${id}`)
  } catch (err) {
    throw err
  }
}

export const findCoupon = async code => {
  try {
    return await Vue.axios.get(`${API_ROOT}/mycoupons/${code}`)
  } catch (err) {
    throw err
  }
}

export const fetchMyPayments = async data => {
  try {
    return await Vue.axios.get(`${API_ROOT}/mypayments`, data)
  } catch (err) {
    throw err
  }
}



// WEBPACK FOOTER //
// ./src/app/store/api.js